/**
 * AGENT_USAGE → the task's token counts (types.ts TokenUsage), and the copy the
 * completion footer keeps of them.
 */
import type { TokenUsage } from "../types";

export interface AgentUsagePayload {
  input_tokens: number;
  output_tokens: number;
  cache_creation_input_tokens?: number;
  cache_read_input_tokens?: number;
}

export function applyAgentUsage(
  tokenUsage: TokenUsage,
  usage: AgentUsagePayload
): void {
  // Set input to latest turn's full context (input + cache = total context window used)
  const cacheRead = usage.cache_read_input_tokens || 0;
  const fullContext =
    (usage.input_tokens || 0) +
    (usage.cache_creation_input_tokens || 0) +
    cacheRead;
  if (fullContext > 0) tokenUsage.input = fullContext;
  tokenUsage.output += usage.output_tokens || 0;
  // The task menu's Usage row: every prompt summed, so its in covers the same
  // span as its out.
  tokenUsage.taskInputTotal = (tokenUsage.taskInputTotal ?? 0) + fullContext;
  tokenUsage.taskCacheReadTotal =
    (tokenUsage.taskCacheReadTotal ?? 0) + cacheRead;
}

/** The completion footer's tokens: the two shared counts, nothing else. */
export function turnTokens(tokenUsage: TokenUsage): {
  input: number;
  output: number;
} {
  return { input: tokenUsage.input, output: tokenUsage.output };
}
